<div *ngIf="inline">
  <p-autoComplete [name]="name" [suggestions]="filteredSettings" [(ngModel)]="value" [dropdown]="true"
    [showClear]="true" [required]="required" field="title" [placeholder]="unset" [showEmptyMessage]="true"
    emptyMessage="Keine passenden Einträge gefunden!" (onSelect)="changes()" (onUnselect)="changes()"
    (completeMethod)="filter($event)" (onClear)="clear()"></p-autoComplete>
</div>
<div class="form-group row" *ngIf="!inline">
  <label [appRequired]="required" class="col-sm-2 col-form-label">{{label}}</label>
  <div class="col-sm-10">
    <span class="p-fluid">
      <p-autoComplete [name]="name" [suggestions]="filteredSettings" [(ngModel)]="value" [dropdown]="true"
        [showClear]="true" [required]="required" field="title" [placeholder]="unset" [showEmptyMessage]="true"
        emptyMessage="Keine passenden Einträge gefunden!" (onSelect)="changes()" (onUnselect)="changes()"
        (completeMethod)="filter($event)" (onClear)="clear()"></p-autoComplete>
    </span>
  </div>
</div>
